export default "__VITE_PUBLIC_ASSET__bb8b76a0__"